/**
 * useKanbanCardsUiTreatment - thin memo wrapper around resolveKanbanCardsUiTreatment
 * (SE-7624).
 *
 * Extracted from MainContainer so the containing component stays under the
 * repo's max-lines-per-function ceiling - the derivation itself is a pure,
 * already-tested function in utils/kanbanCardsState; this hook exists only to
 * memoize its call against React's render cycle.
 * @module features/player-kanban/hooks/useKanbanCardsUiTreatment
 */
import { useMemo } from "react";

import {
  resolveKanbanCardsUiTreatment,
  type KanbanCardsReadState,
  type KanbanCardsUiTreatment,
} from "../utils/kanbanCardsState";

/**
 * Resolves a cards read state to its UI treatment, memoized on the state.
 * @param cardsState - The cards read's resolution state.
 * @returns The treatment the board surface should apply.
 */
export const useKanbanCardsUiTreatment = (
  cardsState: KanbanCardsReadState
): KanbanCardsUiTreatment =>
  useMemo(() => resolveKanbanCardsUiTreatment(cardsState), [cardsState]);
